export enum CalculatorStyles 
{
	block = 'block',
	inline = 'inline'
}
export enum EOfferTypePillText
{
	FinanceText = 'Finance Offer',
	FinanceFsl = 'Finance Offer',
	VehicleText = 'Driveaway Offer',
	VehiclePrice = 'Driveaway Offer'	
}
export enum EOfferType
{
	FinanceText = 1,
	FinanceFsl = 2,
	VehicleText = 3,
	VehiclePrice = 4
}
export enum EFSLToggle
{
	finance = 'Finance',
	fsl = 'Full-Service Lease',
	novated = 'Novated Lease'
}
export enum EFinanceToggleTypes 
{
	cash = 'cash',
	finance = 'finance',
	fsl = 'fsl',
	novated = 'novated',
}
export enum EEnv {
	qa,
	staging,
	live
}
export enum EHeaderStripStyles {
	solid = "solid",
	brand = "brand"
}
export enum ESpecialItemDisclaimerTypes {
	driveaway = "Driveaway",
	special = "Special"
}
export enum EInternalFinanceTypes {
	indicative = "Indicative",
	campaign = "Campaign"
}
export enum EDetailFormTabs {
	enquire = 0,
	book = 1,
	contact = 2
}
export enum EFieldDateTimeTypes {
	date = "date",
	time = "time"
}
export enum ESpecialTypes {
	specialOffer = "Special Offer",
	greatValue = "Great Value",
	dealerSpecial = "Dealer Special"
}
export enum EFinanceTypes {
	AccessConsumer = 1,
	AccessBusiness = 2,
	Business = 3,
	Consumer = 4
}
export enum EStockTypes {
	Pipe = 1,
	Stock = 2,
	Virtual = 3
}
export enum EToggles {
	trim, 
	paint,
	roof
}
export enum EImage360Sizes {
	w260 = "260x146",
	w519 = "519x292",
	w907 = "907x510",
	w940 = "940x529",
	w1920 = "1920x1080",
	w3840 = "3840x2160"
}
export enum EImageHeroSizes {
	w260 = "260x146",
	w519 = "519x292",
	w907 = "907x510",
	w1193 = "1193x671"
}
export enum EImageIntExtSizes {
	w260x146 = "260x146",
	w519x292 = "519x292",
	w907x510 = "907x510",
	w1920x1080 = "1920x1080"
}
export enum EVideoSizes {
	w640x360 = "640x360",
	w960x540 = "960x540",
	w1280x720 = "1280x720",
	w1920x1080 = "1920x1080"
}
export enum EImageExtensions {
	png = "png", 
	jpg = "jpg",
	mp4 = "mp4"
}
export enum EImageType {
	p360 = "Path_360",
	pInt = "Path_Int",
	pExt = "Path_Ext",
	pVid = "Path_Video",
	pHero = "Path_Hero"
}
export enum EFrameType {
	relative = "relative", 
	full = "full"
}
export enum EFormType {
	enquire = "enquire",
	testdrive = "testdrive"
}
export enum EFormTheme {
	onWhite = "onWhite",
	onGrey = "onGrey"
}
export enum EFormRadioCheckTypes {
	radio = "radio",
	checkbox = "checkbox"
}
export enum EYesNo {
	yes = "yes",
	no = "no"
}
export enum ELoadingColour {
	light = "light",
	dark = "dark"
}